/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface TopAggregatedRecordRequestDto
 */
export interface TopAggregatedRecordRequestDto {

    /**
     * @type {string}
     * @memberof TopAggregatedRecordRequestDto
     */
    displayField: string;

    /**
     * @type {string}
     * @memberof TopAggregatedRecordRequestDto
     */
    filterField: string;

    /**
     * @type {string | number}
     * @memberof TopAggregatedRecordRequestDto
     */
    filterValue?: string | number;

    /**
     * @type {string}
     * @memberof TopAggregatedRecordRequestDto
     */
    aggFn?: TopAggregatedRecordRequestDtoAggFnEnum;

    /**
     * @type {string}
     * @memberof TopAggregatedRecordRequestDto
     */
    aggField?: string;

    /**
     * @type {boolean}
     * @memberof TopAggregatedRecordRequestDto
     */
    isCount?: boolean;

    /**
     * @type {boolean}
     * @memberof TopAggregatedRecordRequestDto
     */
    isCountAndCompare?: boolean;

    /**
     * @type {number}
     * @memberof TopAggregatedRecordRequestDto
     */
    size?: number;

    /**
     * @type {string}
     * @memberof TopAggregatedRecordRequestDto
     */
    order?: TopAggregatedRecordRequestDtoOrderEnum;

    /**
     * @type {string}
     * @memberof TopAggregatedRecordRequestDto
     */
    from: string;

    /**
     * @type {string}
     * @memberof TopAggregatedRecordRequestDto
     */
    to: string;
}

/**
 * @export
 * @enum {string}
 */
export enum TopAggregatedRecordRequestDtoAggFnEnum {
    Max = 'max',
    Min = 'min',
    Sum = 'sum',
    Avg = 'avg',
    Std = 'std',
    Count = 'count'
}
/**
 * @export
 * @enum {string}
 */
export enum TopAggregatedRecordRequestDtoOrderEnum {
    ASC = 'ASC',
    DESC = 'DESC'
}

